const VALID_CODE_PATTERN = /^[a-zA-Z0-9]{8,15}$/

const isReferralCode = maybeValidCode => {
  if (!maybeValidCode) {
    return true
  }

  return (
    typeof maybeValidCode === 'string' &&
    VALID_CODE_PATTERN.test(maybeValidCode)
  )
}

export default isReferralCode
